// Icon: material-symbols:resize-rounded
// Slug: Runs an expression on element resize.
// Description: Runs an expression whenever an element’s dimensions change.

import { attribute } from '@engine'
import { beginBatch, endBatch } from '@engine/signals'
import { modifyTiming } from '@utils/timing'
import { modifyViewTransition } from '@utils/view-transitions'

attribute({
  name: 'on-resize',
  requirement: {
    key: 'denied',
    value: 'must',
  },
  apply({ el, mods, rx }) {
    let callback = () => {
      beginBatch()
      rx()
      endBatch()
    }
    callback = modifyViewTransition(callback, mods)
    callback = modifyTiming(callback, mods)
    let resizeObserver: ResizeObserver | null = new ResizeObserver(() => {
      callback()
    })
    resizeObserver.observe(el)
    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect()
        resizeObserver = null
      }
    }
  },
})
